import { sortProductVersionsMainFirst } from './sortProductVersionsMainFirst';
import type { GroupProductEntry } from './iterateGroupProducts';

function compareLocale(a: string, b: string): number {
	return a.localeCompare(b, 'cs', { sensitivity: 'base' });
}

function productSortKey(entry: GroupProductEntry): { brand: string; description: string } {
	const mainVersion = sortProductVersionsMainFirst(entry.versions)[0];

	return {
		brand: mainVersion?.brand ?? '',
		description: mainVersion?.description ?? '',
	};
}

/**
 * Orders products within an ATC/RS group for display: brand A–Z, then pack description A–Z.
 *
 * @param {GroupProductEntry[]} products the products to sort.
 * @returns {GroupProductEntry[]} sorted products.
 */
export function sortGroupProducts(products: GroupProductEntry[]): GroupProductEntry[] {
	return [...products].sort((a, b) => {
		const aKey = productSortKey(a);
		const bKey = productSortKey(b);
		const brandCompare = compareLocale(aKey.brand, bKey.brand);

		if (brandCompare !== 0) {
			return brandCompare;
		}

		return compareLocale(aKey.description, bKey.description);
	});
}
